import { render, staticRenderFns } from "./LDI.vue?vue&type=template&id=088bb5c6&lang=pug"
import script from "./LDI.vue?vue&type=script&lang=js"
export * from "./LDI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports